export default __webpack_public_path__ + "static/media/polygon_up.cf5737ba.svg";